import { loginRes } from '../../Login.res';

export const res = {
  title: {
    is: 'Innskráning með notandanafni',
    en: 'Login with user name',
    pl: 'Logowanie imię użytkownika',
  } as const,
  username: {
    is: 'Notandanafn',
    en: 'User name',
    pl: 'Imię użytkownika',
  } as const,
  password: {
    is: 'Lykilorð',
    en: 'Password',
    pl: 'Hasło',
  } as const,
  validationUsernameRequired: {
    is: 'Notandanafn verður að vera útfyllt',
    en: 'User name is a required field',
    pl: 'Należy wypełnić pole z imieniem użytkownika',
  } as const,
  validationUsernameInvalid: {
    is: 'Notandanafn er ekki rétt skráð',
    en: 'User name is incorrect',
    pl: 'Imię użytkownika jest niepoprawny',
  } as const,
  validationPasswordRequired: {
    is: 'Lykilorð verður að vera útfyllt',
    en: 'Password is a required field',
    pl: 'Należy wypełnić pole z hasłem',
  } as const,
  validationPasswordInvalid: {
    is: 'Lykilorð er ekki rétt skráð',
    en: 'Password format is incorrect',
    pl: 'Hasło jest niepoprawny',
  } as const,
  login: {
    ...loginRes.loginButtonText,
  } as const,
  authenticate: {
    ...loginRes.authenticateButtonText,
  } as const,
};
